import React, { useState, useCallback, useEffect } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function CreateEditUser({ handleClose, notification, action, selectedUser, refreshList }) {
  const orgId = JSON.parse(localStorage.user).organization.id;
  const { userId } = JSON.parse(localStorage.user).user;
  const formModel = {
    userName: '',
    slug: '',
    email: '',
    contact: '',
    avatar: '',
    organizationId: orgId,
    role: '0',
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, postData] = useApi();
  const [state, getDataForUpdate] = useApi();
  const [state2, updateData] = useApi();
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {}, [formData]);

  useEffect(() => {
    if (action === 'update') {
      getDataForUpdate(`/user/${selectedUser}`, 'GET');
    }
  }, [action]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (action === 'create') postData('/user', 'POST', formData);
    else updateData(`/user/${selectedUser}`, 'PATCH', formData);
  };

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'User created successfully');
      handleClose();
      refreshList();
    }

    if (isError) {
      notification('error', 'Unable to create user');
      handleClose();
    }
  }, [isLoading, isError, data]);

  // getUser for update response
  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setFormData(state.data.user);
    }

    if (state.isError) {
      notification('error', 'Unable to fetch user detail');
    }
  }, [state]);

  // update response
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data !== null) {
      notification('success', 'User updated successfully');
      refreshList();
    }
    if (state2.isError) {
      notification('error', 'Unable to update user detail');
    }
    // refreshList();
  }, [state2]);

  return (
    <div
      className="flex justify-center items-center h-full w-full fixed z-20"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
    >
      <div className="bg-white w-2/4 px-5 pt-4 rounded-2xl relative">
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1 border-b p-4">{action === 'create' ? 'New' : 'Edit'} User</p>

        <form className="mt-6 mb-2 mx-10 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="userName" className="block text-parameter w-1/3 text-sm">
              NAME
            </label> */}
            <input
              type="text"
              placeholder="Name"
              value={formData.userName}
              autoComplete="off"
              name="userName"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="slug" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label> */}
            <input
              type="text"
              placeholder="Short Name"
              value={formData.slug}
              autoComplete="off"
              name="slug"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="email" className="block text-parameter w-1/3 text-sm">
              EMAIL
            </label> */}
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              name="email"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="contact" className="block text-parameter w-1/3 text-sm">
              PHONE NUMBER
            </label> */}
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.contact}
              name="contact"
              autoComplete="off"
              className="inputLabelText px-4 py-2 focus:outline-none"
              onChange={handleInputChange}
            />
          </div>

          <div className="mt-5 w-2.25/5 relative">
            {/* <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
              ROLE
            </label> */}

            <div className="inputLabelText px-4 py-2 focus:outline-none">
              <select
                name="role"
                value={formData.role}
                className="border-none w-full focus:outline-none text-sm  text-parameter border "
                onChange={handleInputChange}
              >
                {roles.map((item) => (
                  <option key={item.id} value={item.id} className="fy-4">
                    {item.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="w-1/10" />
          <div className="mt-5 w-2.25/5 relative" />
          <div className="w-7/12 mt-5 mb-2" />
          <div className="w-5/12 mt-5 mb-2 relative">
            {/* <label className="block text-parameter w-1/3 text-sm" /> */}
            {/* <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" /> */}
            {state2.isLoading || isLoading ? (
              <img src="assets/img/loader.svg" className="absolute w-16 right-36 -top-16 mx-auto" alt="" />
            ) : (
              <div className="flex text-xs">
                <button
                  type="submit"
                  onClick={() => handleClose()}
                  className="rounded-3xl border focus:outline-none w-1/2 h-10 mr-3 cursor-pointer "
                  // style={{ border: '1px solid #16406D' }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rounded-3xl focus:outline-none w-1/2 h-10 text-white cursor-pointer"
                  style={{ background: '#16406D' }}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateEditUser;
